import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Col, Grid, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import s from '../content.scss';
import PaperTile from '../../components/PaperTile/PaperTile';
import ServicesCategories from '../../components/ServicesCategories/ServicesCategories';
import PaperHeader from '../../components/PaperHeader/PaperHeader';
import { replaceMultipleSpaces } from '../../lib/utils';

class Euslugi extends React.Component {
  state = {
    filter_text: '',
    categories: [],
    all_service_ids: new Set([]),
    filtered_service_ids: new Set([]),
    serviceCategories: {},
  };

  componentDidMount() {
    this.fetchCategories()
  }

  fetchCategories = () => {
    let serviceCategories = {};
    const all_service_ids = [];
    const url = `${process.env.API_URL}/eservices/service_categories/`;
    fetch(url)
      .then(r => r.json())
      .then(resp => {
        serviceCategories = resp;
        Object.keys(serviceCategories).map(
          (service) =>
          all_service_ids.push(...serviceCategories[service]),
          );
        this.setState({ serviceCategories, all_service_ids: new Set(all_service_ids), filtered_service_ids: new Set(all_service_ids) });
      });
  }

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  categoryFilterChange = (categoryId) => {
    let categories = this.state.categories;
    let filtered_service_ids = this.state.filtered_service_ids;

    if (categories.some(category => category === categoryId)) {
      categories = categories.filter(item => item !== categoryId);
    } else {
      categories.push(categoryId);
    }

    if (categories.length === 0) {
      filtered_service_ids = new Set(this.state.all_service_ids);
    } else {
      const serviceIds = [];
      categories.map(
        (category) =>
        serviceIds.push(...this.state.serviceCategories[category]),
        );
        filtered_service_ids = new Set(serviceIds);
    }
    this.setState({ categories, filtered_service_ids });
  };

  renderServicesList = (title, servicesList) => {
    return (
      <div className="col-lg-12" style={{ display: 'flow-root' }}>
        <PaperHeader title={title} text="" />
        {servicesList.map(
        (service, i) =>
          <Col key={i + 'service1'} md={12}><PaperTile href={`/euslugi/${service}`} text={this.props.eservices[service].title} epuap={this.props.eservices[service].requiresEPUAP}/></Col>,
          )}
      </div>
    );
  };

  render() {
    const servicesWithoutLogging = this.props.eservices && Object.keys(this.props.eservices)
    .filter(service => 
        !this.props.eservices[service].requiresUserInfo &&
        this.props.eservices[service].isEnabled &&
        this.props.eservices[service].title.toLowerCase().includes(this.state.filter_text.toLowerCase()) &&
        this.state.filtered_service_ids.has(this.props.eservices[service].id))
    .sort((a, b) => {
        const titleA = this.props.eservices[a].title.toLowerCase();
        const titleB = this.props.eservices[b].title.toLowerCase();
        
        return titleA.localeCompare(titleB);
    });
    const servicesWithLogging = this.props.eservices && Object.keys(this.props.eservices)
    .filter(service => 
        this.props.eservices[service].requiresUserInfo &&
        this.props.eservices[service].isEnabled &&
        this.props.eservices[service].title.toLowerCase().includes(this.state.filter_text.toLowerCase()) &&
        this.state.filtered_service_ids.has(this.props.eservices[service].id))
    .sort((a, b) => {
        const titleA = this.props.eservices[a].title.toLowerCase();
        const titleB = this.props.eservices[b].title.toLowerCase();
        
        return titleA.localeCompare(titleB); 
    });
    return (
      <div>
        <div className="row">
          <div className="col-lg-12" style={{ display: 'flow-root' }}>
            <PaperHeader title="Kategorie e-usług" text="" />
          </div>
          <div className="col-lg-12" style={{ display: 'flow-root' }}>
          <ServicesCategories onChange={this.categoryFilterChange} />
          </div>
          <div className="col-lg-12" style={{ display: 'flow-root' }}>
            <PaperHeader title="Wyszukiwarka e-usług" text="" />
          </div>
          <input
            type="text"
            className="form-control"
            style={{ width: '60%', left: '20%', position: 'relative', margin: '25px 0px 15px 0px', fontSize: `${this.props.fontSize}rem` }}
            value={this.state.filter_text}
            placeholder="Wyszukaj usługę..."
            onChange={(e) => this.serviceFilterChange(e)}
            aria-label="Wprowadź tekst aby wyszukać e-usługę"
          />
          {servicesWithoutLogging && servicesWithoutLogging.length > 0 ?
            this.renderServicesList('Lista e-usług niewymagających logowania', servicesWithoutLogging)
            : null}

          {servicesWithLogging 	&& servicesWithLogging.length > 0 ?
            this.renderServicesList('Lista e-usług wymagających logowania', servicesWithLogging)
            : null}
          {servicesWithoutLogging && servicesWithoutLogging.length === 0 && servicesWithLogging && servicesWithLogging.length === 0 ?
            <div className="col-lg-12">
              <p style={{ textAlign: 'center' }}>Brak wyników wyszukiwania</p>
            </div>
          : null}
        </div>
        {/* // aleksandrów */}
        {/* <Link to={`/services?customerId=${customerId}&district=1020043&serviceType=uproszczony_wypis`}>Uproszczony wypis</Link> */}
      </div>
    );
  }
}
const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts,
  fontSize: state.runtime.fontSize,
});

export default withStyles(s)(connect(mapState)(Euslugi));



// WEBPACK FOOTER //
// src/routes/euslugi/Euslugi.js